/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sort': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M160.9 436.7h678.3c33 0 40.9-18.9 17.5-42.3L542.3 80c-23.4-23.4-61.2-23.4-84.5 0L143.4 394.4c-23.4 23.4-15.6 42.3 17.5 42.3zm678.2 126.6H160.9c-33 0-40.9 18.9-17.5 42.3L457.7 920c23.4 23.4 61.2 23.4 84.5 0l314.4-314.4c23.4-23.4 15.5-42.3-17.5-42.3z"/>'
  }
})
